<template>
  <main-large-dialog
    :is-visible.sync="computedIsVisible"
    :title="$i18n.t('dialog.title.settings')"
    agree-text="dialog.save"
    dialog-width="600px"
    min-body-height="50px"
    no-paddings-y
    no-paddings-x
    header-shadow
    @agree="save"
    :loading="saving"
  >
    <template #body>
      <v-row fill-height no-gutters>
        <v-col v-if="isFetching">
          <main-loader></main-loader>
        </v-col>
        <v-col v-else class="px-10 py-4">
          <admin-wrapper
            hide-title-row
            :has-buttons="false"
            :inputs="inputs"
            :is-super-admin="true"
            :is-form-fetched="!isFetching"
          >
            <template #[`attribute_table_row_height.input`]="data">
              <v-col cols="7">
                <data-input
                  v-bind="data"
                  v-model="params[data.name]"
                  :data-type="{ name: 'slider' }"
                  :min="tableRowHeightRange.min"
                  :max="tableRowHeightRange.max"
                >
                  <template #valueLabel>
                    <v-col cols="3" class="value-label pl-0 text-center pt-3 d-flex align-center" align-self="center">
                      <data-input
                        style="width: 57px !important; min-width: 57px !important"
                        v-model="params[data.name]"
                        :data-type="{ name: 'integer' }"
                        @input="inputTableRowHeightInput"
                      />
                      <span class="pl-2">px</span>
                    </v-col>
                  </template>
                </data-input>
              </v-col>
            </template>
            <template #key_bindings.input="data">
              <key-bindings v-model="params[data.name]" />
            </template>
          </admin-wrapper>
        </v-col>
      </v-row>
    </template>
  </main-large-dialog>
</template>

<script>
import MainLargeDialog from '@/components/MainLargeDialog';
import MainLoader from '@/components/MainLoader';
import AdminWrapper from '@/components/AdminWrapper';
import DataInput from '@/components/DataInput';
import KeyBindings from '@/components/KeyBindings';

import { get, call } from 'vuex-pathify';

export default {
  name: 'UserSettingsDialog',
  components: {
    MainLargeDialog,
    MainLoader,
    AdminWrapper,
    DataInput,
    KeyBindings,
  },
  props: {
    isVisible: {
      type: Boolean,
      required: true,
    },
  },
  data: () => ({
    tableRowHeightRange: {
      min: 25,
      max: 48,
    },
    params: {
      attribute_table_row_height: 0,
      key_bindings: [],
    },
    isFetching: false,
    saving: false,
    notNamedSettings: ['key_bindings'],
  }),
  computed: {
    userSettings: get('users/currentUser@settings'),
    userId: get('users/currentUser@id'),
    keyBindings: get('admin/settingsValues@key_bindings_tools_enabled'),
    computedIsVisible: {
      get() {
        return this.isVisible;
      },
      set(nV) {
        this.$emit('update:isVisible', nV);
      },
    },
    inputs() {
      return Object.keys(this.userSettings).map(name => {
        return {
          name,
          translationPath: `dialog.userSettings.${name}`,
          titleCols: 5,
          align: 'center',
          rules: [v => !!v || v == '0' || 'rules.required'],
          ...(this.notNamedSettings.includes(name) ? { isNamedSlot: false } : {}),
        };
      });
    },
  },
  methods: {
    editUserSettings: call('users/editUserSettings'),
    inputTableRowHeightInput(e) {
      if (!e) this.params['attribute_table_row_height'] = this.tableRowHeightRange.min;
    },
    async save() {
      this.saving = true;
      try {
        await this.editUserSettings({
          userId: this.userId,
          payload: this.params,
        });
        this.$store.set('snackbar/PUSH_SUCCESSFULLY_MESSAGE!', {
          message: this.$i18n.t('success.successSaveChanges'),
        });
      } finally {
        this.saving = false;
        this.computedIsVisible = false;
      }
    },
  },
  watch: {
    userSettings: {
      immediate: true,
      handler(nV) {
        if (!nV) return;
        Object.entries(nV).map(([name, value]) => {
          if (name === 'key_bindings') {
            this.params[name] = this.keyBindings.map(keyBinding => {
              const keyBind = value.find(bind => bind.verboseName === keyBinding.verboseName)?.keyBind;
              return { ...keyBinding, keyBind };
            });
          } else {
            this.params[name] = value;
          }
        });
      },
    },
  },
};
</script>
